// React
import React from "react";

// Styles
import "./styles.css";

function LoadingDots() {
  return (
    <div className="loading-dots">
      <div className="loading-dots--dot"></div>
      <div className="loading-dots--dot"></div>
      <div className="loading-dots--dot"></div>
    </div>
  );
}

export default LoadingDots;
